import { CallApiOptions } from './api';

export const fetchCategoriesCallOptions = (
  appId: number,
  topCat: string = 'frauen'
): CallApiOptions => ({
  method: 'GET',
  endpoint: `proxies/mobile/${appId}/categories/${topCat}`,
});



// WEBPACK FOOTER //
// ./src/services/categories.services.ts